// package imports
import { Session } from 'next-auth';
import { Theme as MuiTheme } from '@mui/material/styles';
import { useTheme } from '@emotion/react';

// local imports
import { SiteHeaderType } from '../SiteHeaderTypes';
import NavigationMenu from './NavigationMenu';
import { themeColor } from 'services/styleUtils/colorUtils';
import { LessonPlan } from 'types/AgilityTypes';
import { SIGN_OUT_TEXT } from '../SiteHeaderConstants';
import { doSignOut, filterNavigationLinks } from '../SiteHeaderUtils';
import { useMemo } from 'react';

const MegaMenuNav = ({
  headerFields,
  session,
  lessonPlanOfTheWeek,
}: {
  headerFields: SiteHeaderType;
  session: Session | null;
  lessonPlanOfTheWeek?: LessonPlan;
}) => {
  const theme = useTheme() as MuiTheme;
  const links = useMemo(
    () =>
      filterNavigationLinks(headerFields.fields.leftLinkList ?? [], session),
    [headerFields, session],
  );

  return (
    <div className="bg-gray-100 min-h-[300px]">
      <div className="w-full mx-auto px-4 md:px-6 lg:px-10 grid gap-12 grid-cols-[20%,auto] py-12 max-w-[1392px]">
        <div className="pr-12 border-r border-gray-300 text-sm">
          <ul className="grid gap-4">
            {links.map((link) => {
              return (
                <li key={link.contentID}>
                  <a
                    style={{
                      color: themeColor(
                        theme,
                        link.fields?.textColor?.fields?.color ?? 'primary.dark',
                      ),
                    }}
                    className="underline-offset-4 hover:underline font-semibold"
                    onClick={async (e) => {
                      if (
                        link.fields?.link?.text?.toLowerCase() ===
                          SIGN_OUT_TEXT &&
                        session
                      ) {
                        e.preventDefault();
                        e.stopPropagation();
                        await doSignOut(session);
                      }
                    }}
                    href={
                      link.fields?.link?.text?.toLowerCase() === SIGN_OUT_TEXT
                        ? '#'
                        : link.fields.link.href
                    }
                    //href={link.fields.link.href}
                    target={link.fields.link.target}
                    rel="noopener noreferrer"
                  >
                    {link.fields.link.text}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="text-sm">
          <NavigationMenu
            headerFields={headerFields}
            session={session}
            lessonPlanOfTheWeek={lessonPlanOfTheWeek}
          />
        </div>
      </div>
    </div>
  );
};

export default MegaMenuNav;
